// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.9995 2H1.99951V22H21.9995V2ZM12.9995 18H10.9995V7H12.9995V18ZM7.99951 18H5.99951V11H7.99951V18ZM15.9995 18V13H17.9995V18H15.9995Z"}}]};

const ChartFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-filled',
    ref,
    icon: element,
  },
));

ChartFilledIcon.displayName = 'ChartFilledIcon';

export default ChartFilledIcon;
